import dayjs from 'dayjs';
import en from 'dayjs/locale/en';
import fr from 'dayjs/locale/fr';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export class DateFormatter {
	static since(date: Date, lang: string = 'fr') {
		const locale = lang == 'fr' ? fr : en;
		return dayjs(date).locale(locale).fromNow();
	}

	static format(date: Date, lang: string = 'fr') {
		const locale = lang == 'fr' ? fr : en;
		const string = lang == 'fr' ? 'D MMMM YYYY à H:mm' : 'MMMM D YYYY [at] h:mm A';
		return dayjs(date).locale(locale).format(string);
	}

	static sameDate(date1: Date, date2: Date) {
		return dayjs(date1).isSame(date2, 'minute');
	}
}
